import React, { useState, useEffect } from 'react';
import DigitalWorkerTaskTable from './DigitalWorkerTaskTable';
import moment from 'moment';



const DigitalWorkerTaskDetails = (props) => {

    const [taskheaders] = useState([
        {
            key: 'task_name',
            header: 'Task Name'
        },
        {
            key: 'start_time',
            header: 'Start Time'
        },{
            key: 'end_time',
            header: 'End time'
        },
        {
            key: 'task_status',
            header: 'Status'
        },
        {
            key: 'duration',
            header: 'Duration (minutes)'
        },
    ]);

   
    const [rows, setRows] = useState([]);
    const [fullRows, setFullRows] = useState([]);

    useEffect(() => {
        prepareRowData();
    }, [props.digitalWorkerData])

    function modifyData(data) {
        let modifiedElement;
        let result = data.map((element, index) => {
            modifiedElement = element;
            modifiedElement.id =  index+1;
            modifiedElement.status = element.task_status;
            modifiedElement.duration = getDuration(element.start_time,element.end_time);
            return modifiedElement;
        });
        return result;
    }

    const getDuration = (starttime, endTime) => {
        let duration;
        if(starttime && endTime) {
        let endDate = moment(endTime);
        let startDate = moment(starttime);
        duration = moment.duration(endDate.diff(startDate));
        duration = parseFloat(duration.as('minutes')).toFixed(2)
        }
        return duration;

    }
    function prepareRowData() {
        let data = props.digitalWorkerData ? props.digitalWorkerData : [];
        let result = modifyData(data);
        setRows(result);
        setFullRows(data);
    }

    return (
        <div>
          <DigitalWorkerTaskTable rows={rows} headers={taskheaders}/>
        </div>
    );
};

export default DigitalWorkerTaskDetails;
